/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { MenuComponent } from '../../../../../../../_metronic/assets/ts/components'
import { ID, KTSVG, QUERIES } from '../../../../../../../_metronic/helpers'
import { CreateAppModal } from '../../../../../../../_metronic/partials'
import { useListView } from '../../core/ListViewProvider'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { archiveClient } from '../../core/_requests'

type Props = {
  id: ID
}

const ClientActionsCell: FC<Props> = ({ id }) => {
  const { setItemIdForUpdate, setItemIdForDelete } = useListView()
  const { query } = useQueryResponse()
  const queryClient = useQueryClient()

  const [showCreateAppModal, setShowCreateAppModal] = useState<boolean>(false)

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  const openEditModal = () => {
    setItemIdForUpdate(id)
  }

  const deleteItem = useMutation(() => archiveClient(id), {
    // 💡 response of the mutation is passed to onSuccess
    onSuccess: () => {
      // ✅ update detail view directly
      queryClient.invalidateQueries([`${QUERIES.CLIENTS_LIST}-${query}`])
    },
  })

  return (
    <>
      <a
        href='#'
        className='btn btn-light btn-active-light-primary btn-sm'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-end'
      >
        Actions
        <KTSVG path='/media/icons/duotune/arrows/arr072.svg' className='svg-icon-5 m-0' />
      </a>
      {/* begin::Menu */}
      <div
        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-4'
        data-kt-menu='true'
      >
        {/* begin::Menu item */}
        <div className='menu-item px-3'>
          <a className='menu-link px-3' onClick={openEditModal}>
            Edit
          </a>
        </div>
        {/* end::Menu item */}
        {/* begin::Menu item */}
        {/* <div className='menu-item px-3'>
          <a className='menu-link px-3' onClick={() => setShowCreateAppModal(true)}>
            Assign User
          </a>
        </div> */}

        {/* end::Menu item */}

        {/* begin::Menu item */}
        <div className='menu-item px-3'>
          <a
            className='menu-link px-3'
            data-kt-clients-table-filter='delete_row'
            onClick={() => setItemIdForDelete(id)}
          // onClick={async () => await deleteItem.mutateAsync()}
          >
            Archive
          </a>
        </div>
        {/* end::Menu item */}
      </div>

      <CreateAppModal type={'Clients'} show={showCreateAppModal} handleClose={() => setShowCreateAppModal(false)} />

      {/* end::Menu */}
    </>
  )
}

export { ClientActionsCell }
